<template>
  <div class="small" :class="normStatus">
    <doughnut-chart id="waste-gauge-chart"
                    :height="300"
                    :width="720"
                    :chart-data="gaugeData"
                    :options="chartOptions"
    ></doughnut-chart>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DoughnutChart from './DoughnutChart'

export default {
  components: {
    DoughnutChart
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        cutoutPercentage: 70,
        elements: {
          arc: {
            borderWidth: 0
          }
        }
      },
      norm: 0,
      wasteStatus: false,
    }
  },
  computed: {
    ...mapGetters([
      'getTotalFromBatch',
      'getBatch',
      'getNormValue'
    ]),
    gaugeData() {
      var backGroundcolor = ['#119b48', '#cccccc']
      if (parseInt(this.getTotalFromBatch.percentage) > (this.getBatch ?  this.getBatch.product.norm : 0) ) {
        // var className = parseInt(this.getTotalFromBatch.percentage) < this.getBatch ?  this.getBatch.product.norm : 100  ? 'status-green' : 'status-red';
        // console.log(className)
        // this.$emit('normStatusClass',className)
        backGroundcolor = ['#119b48', '#cccccc'];
      } else {
        backGroundcolor = ['#e51e22', '#cccccc']
      }
      return {
        datasets: [
          {
            backgroundColor: backGroundcolor,
            data: [parseInt(this.getTotalFromBatch.percentage), (parseInt(this.getTotalFromBatch.percentage - 100))]
          },
        ]
      }
    },
    normStatus() {
      var className = parseInt(this.getTotalFromBatch.percentage) >  (this.getBatch ?  this.getBatch.product.norm : 0)  ? 'status-green' : 'status-red';
      this.$emit('normStatusClass',className)
      return className
    }
  },
}
</script>

<style>

</style>